import React from 'react';
import PropTypes from 'prop-types';
import { cva } from 'class-variance-authority';
import cn from '../utils/cn';
import styles from './IconButton.module.css';

const iconButton = cva(styles.root, {
  variants: {
    variant: {
      round: styles.round,
      nav: styles.nav,
      floatHeart: styles.floatHeart
    }
  },
  defaultVariants: { variant: 'round' }
});

const IconButton = React.forwardRef(function IconButton(
  { variant, type = 'button', className, children, ...rest },
  ref
) {
  if (process.env.NODE_ENV !== 'production' && !rest['aria-label']) {
    console.warn('IconButton: aria-label is required for accessibility.');
  }
  return (
    <button
      ref={ref}
      type={type}
      className={cn(iconButton({ variant }), className)}
      {...rest}>
      {children}
    </button>
  );
});

IconButton.propTypes = {
  variant: PropTypes.oneOf(['round', 'nav', 'floatHeart']),
  'aria-label': PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};

export default IconButton;
